export const OPTHINES = {
  voteName: '2019poject/2019economic',
  mustSearch: 'Button',
  buttonBg: '#d83334',
  number: {
    mustRank: false,
  },
  name: true,
  content: true,
  user: true,
  checkBox: false,
  themeColor: {
    activeBgColor: '#c36e00',
    inactiveBgColor: '#fdde7e',
  },
  tabs: [
    // {
    //   tabName: '人物点赞',
    //   tabPath: '/2019VoteForTopTenChongqingMerchants/givelike',
    // },
    {
      tabName: '获奖渝商',
      tabPath: '/2019VoteForTopTenChongqingMerchants/winner-list',
    },
    {
      tabName: '相关新闻',
      tabPath: '/2019VoteForTopTenChongqingMerchants/news',
    },

    {
      tabName: '评选规则',
      tabPath: '/2019VoteForTopTenChongqingMerchants/rules',
    },
  ],
};
